import React from 'react';
import { RichUtils } from 'draft-js';
import { BiBold, BiFontColor, BiFontSize, BiItalic, BiListUl, BiStrikethrough, BiUnderline } from 'react-icons/bi';
import { ContextMenu } from '@shared/contextmenu';
import { changeColorStyle, changeFontStyle, CustomTextColorStyle, CustomTextSizeStyle } from './editorStyles';
import { appColors } from '../../styled/useTheme';
function createColorBox(color) {
    return function () { return (React.createElement("div", { style: {
            minHeight: '2em',
            maxHeight: '2em',
            minWidth: '2em',
            maxWidth: '2em',
            backgroundColor: color,
            cursor: 'pointer',
            borderRadius: '5px',
        } })); };
}
export default function TextEditMenu(_a) {
    var wrapperRef = _a.wrapperRef, editorState = _a.editorState, updateEditorState = _a.updateEditorState, _b = _a.visible, visible = _b === void 0 ? true : _b;
    var handleClick = function (action) {
        var newState = action === 'LIST'
            ? RichUtils.toggleBlockType(editorState, 'unordered-list-item')
            : RichUtils.toggleInlineStyle(editorState, action);
        if (newState !== null && newState !== editorState) {
            updateEditorState(newState);
        }
    };
    var handleFontChange = function (sizeStyle) {
        var newState = changeFontStyle(editorState, sizeStyle);
        if (newState !== editorState) {
            updateEditorState(newState);
        }
    };
    var handleColorChange = function (colorStyle) {
        var newState = changeColorStyle(editorState, colorStyle);
        if (newState !== editorState) {
            updateEditorState(newState);
        }
    };
    var menuItems = [
        { icon: BiBold, action: function () { return handleClick('BOLD'); } },
        { icon: BiItalic, action: function () { return handleClick('ITALIC'); } },
        { icon: BiUnderline, action: function () { return handleClick('UNDERLINE'); } },
        { icon: BiStrikethrough, action: function () { return handleClick('STRIKETHROUGH'); } },
        { spacer: true },
        {
            icon: BiFontSize,
            items: [
                { actionName: '10', action: function () { return handleFontChange(CustomTextSizeStyle.SIZE_10); } },
                { actionName: '12', action: function () { return handleFontChange(CustomTextSizeStyle.SIZE_12); } },
                { actionName: '14', action: function () { return handleFontChange(CustomTextSizeStyle.SIZE_14); } },
                { actionName: '18', action: function () { return handleFontChange(CustomTextSizeStyle.SIZE_18); } },
            ],
        },
        { spacer: true },
        {
            icon: BiFontColor,
            items: [
                {
                    Component: createColorBox(appColors.ui.dark),
                    action: function () { return handleColorChange(CustomTextColorStyle.COLOR_UI); },
                },
                {
                    Component: createColorBox(appColors.primary.w500),
                    action: function () { return handleColorChange(CustomTextColorStyle.COLOR_PRIMARY); },
                },
                {
                    Component: createColorBox(appColors.error.w500),
                    action: function () { return handleColorChange(CustomTextColorStyle.COLOR_ERROR); },
                },
                {
                    Component: createColorBox(appColors.neutral.w700),
                    action: function () { return handleColorChange(CustomTextColorStyle.COLOR_NEUTRAL); },
                },
            ],
        },
        { spacer: true },
        { icon: BiListUl, action: function () { return handleClick('LIST'); } },
    ];
    return (React.createElement(ContextMenu, { items: menuItems, triggerRefs: [{ ref: wrapperRef }], visible: visible, direction: "horizontal", preventDefault: true }));
}
